// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('support.supportcases.deleteproduct', {
        url:'/deleteproduct',
        views: {
            'supportView@support': {
            templateUrl: 'main/support/supportcases/deleteproduct/deleteproduct.tpl.html',
            controller: 'SupportCaseDeleteProductController as vm'
        }},
        resolve: {
        }
    });
}

// @ngInject
function SupportCaseDeleteProductController($state, $scope, SupportApiService, loadSpinnerService, ToasterService, confirmationDialogService, $translate) {
    var vm = this;

    //Properties
    vm.selectedProduct = {};

    //Methods
    vm.recieveProduct = recieveProduct;
    vm.removeProduct = removeProduct;
    vm.isAllowedToDelete = isAllowedToDelete;
    vm.deleteProduct = deleteProduct;

    activate();

    function activate() {
    }

    function deleteProduct() {
        confirmationDialogService.showDialog('<div>' + $translate.instant("support.confirmDeleteData") + '</div>').then(function (result) {
            if (result === true) {
                loadSpinnerService.start("mainSpinner");
                SupportApiService.deleteProduct(vm.selectedProduct.id).then(function(response) {
                    $scope.$broadcast('clearArticleEvent');
                    ToasterService.showSuccess($translate.instant('support.productDeleted'), $translate.instant('support.supportCase'));
                }, function(error) {
                    ToasterService.showError(error.message, $translate.instant('common.error'));
                }).finally(function() {
                    loadSpinnerService.stop("mainSpinner");
                });
            }
        });
    }

    function recieveProduct(product) {
        vm.selectedProduct = product;
    }
    function removeProduct() {
        vm.selectedProduct = {};
    }

    function isAllowedToDelete() {
        return vm.selectedProduct && vm.selectedProduct.id > 0;
    }
}

angular
    .module('supportcases.deleteproduct', ['support.api'])
    .config(stateConfig)
    .controller('SupportCaseDeleteProductController', SupportCaseDeleteProductController);
